/**
 * Currency codes supported by the platform
 * 
 * Based on ISO 4217 currency codes.
 * Currently supports North American currencies (USD, CAD).
 */
export enum CurrencyCode {
  /** United States Dollar */
  USD = 'USD',
  /** Canadian Dollar */
  CAD = 'CAD',
}

/**
 * Type alias for currency code
 */
export type Currency = CurrencyCode;

/**
 * Converts a string to a CurrencyCode enum value
 * 
 * @param value - String to convert
 * @returns CurrencyCode if valid, undefined otherwise
 */
export function convertStringToCurrencyCode(value: string): CurrencyCode | undefined {
  return (Object.values(CurrencyCode) as Array<string>).includes(value) 
    ? (value as CurrencyCode) 
    : undefined;
}

/**
 * Gets the currency symbol for a given currency code
 * 
 * @param code - Currency code
 * @returns Currency symbol (e.g., "$")
 */
export function getCurrencySymbol(code: CurrencyCode): string {
  switch (code) {
    case CurrencyCode.USD:
    case CurrencyCode.CAD:
      return '$';
    default:
      return code;
  }
}
